import type { ReactElement } from 'react';
import { Route } from 'config';

import Link from '../App/Sidebar/Link';

function SidebarNavigation(): ReactElement {
  return (
    <nav
      className="c-nav-account-sidebar"
      aria-label="Account navigation"
      data-fragment="sidenav-account-desktop"
    >
      <ul>
        <Link
          href={Route.PROFILE}
          data-cy="sidebar-nav-profile"
        >
          Subscription
        </Link>

        <Link
          href={Route.ACCOUNT_SETTINGS}
          data-cy="sidebar-nav-account-settings"
        >
          Account Settings
        </Link>

        <Link
          href={Route.PAYMENT_METHOD}
          data-cy="sidebar-nav-payment-method"
        >
          Payment Method
        </Link>

        <Link
          href={Route.DELIVERY_ADDRESS}
          data-cy="sidebar-nav-address"
        >
          Delivery Address
        </Link>

        <Link
          href={Route.NOTIFICATION_PREFERENCES}
          data-cy="sidebar-nav-notification-preferences"
        >
          Notification Preferences
        </Link>

        <li className="c-nav-account-sidebar__divider" />
      </ul>
    </nav>
  );
}

export default SidebarNavigation;
